import React, {useState,useEffect} from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Sidebar from './Sidebar';
import Familiarization from '../pages/Familiarization';
import './Layout.css';
import { canOpen, roleLabels, roleDescriptions } from '../services/access';

export default function Layout() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [sidebarCollapsed,setSidebarCollapsed]=useState(()=>{
    try{return window.localStorage.getItem('segmira.sidebar.collapsed')==='1';}catch{return false;}
  });
  useEffect(()=>{
    try{window.localStorage.setItem('segmira.sidebar.collapsed',sidebarCollapsed?'1':'0');}catch{}
  },[sidebarCollapsed]);

  if (loading) {
    return <div className="loading-screen">Загрузка...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={`layout ${sidebarCollapsed?'sidebar-is-collapsed':''}`}>
      <Sidebar collapsed={sidebarCollapsed} onHome={()=>setSidebarCollapsed(true)} onToggle={()=>setSidebarCollapsed(value=>!value)} />
      <main className="layout-main">
        {!canOpen(user.role, pathname) ? <div role="alert"><h1>Нет доступа к разделу</h1><p>Обратитесь к владельцу аккаунта.</p></div> : <>
          {user.role !== 'owner' && user.role !== 'familiarization' && <div className="card" style={{padding:12,marginBottom:16}} role="note"><strong>{roleLabels[user.role]}</strong> · {roleDescriptions[user.role === 'member' ? 'viewer' : user.role]} Ограниченные действия вернут сообщение о недостатке прав.</div>}
          {user.role === 'familiarization' && pathname !== '/knowledge' ? <Familiarization/> : <Outlet />}
        </>}
      </main>
    </div>
  );
}
